import { render } from "./infoCreatedTesting.vue?vue&type=template&id=3c00f1d0"
import script from "./infoCreatedTesting.vue?vue&type=script&lang=js"
export * from "./infoCreatedTesting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__